import { useState } from "react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";

const ResultColumn = ({
  question,
  totalScore,
  setTotalScore,
  questionScores,
  setQuestionScores,
}) => {
  const [grade, setGrade] = useState(
    question.Score === null ? 100 : question.Score
  );

  const [selected, setSelected] = useState(question.Score === 0 ? 2 : 1);

  return (
    <div className="result">
      <TextField
        className="grade"
        inputProps={{ readOnly: true }}
        value={grade}
      />

      <RadioGroup
        row
        value={selected}
        onChange={(e) => {
          const value = Number(e.target.value);
          setSelected(value);
          let tempQuestionScores = questionScores;

          // if (value === 1) {
          //   setGrade(100);
          // } else if (value === question.resultOptions.length) {
          //   setGrade(0);
          // } else {
          //   setGrade(50);
          // }

          if (value === 1) {
            setGrade(100);
            setTotalScore((totalScore += question.Weight));

            tempQuestionScores[
              questionScores.findIndex(
                (questionScore) => questionScore.id === question.ScoreQuestionID
              )
            ].score = 100;
          } else {
            setGrade(0);
            setTotalScore((totalScore -= question.Weight));

            tempQuestionScores[
              questionScores.findIndex(
                (questionScore) => questionScore.id === question.ScoreQuestionID
              )
            ].score = 0;
          }

          setQuestionScores(tempQuestionScores);
        }}
      >
        {/* {question.Choice ? (
          <> */}
        <FormControlLabel
          control={<Radio className="radio" />}
          label="yes"
          value={1}
        />

        <FormControlLabel
          control={<Radio className="radio" />}
          label="no"
          value={2}
        />
        {/* </>
        ) : (
          question.Choice.map((option, index) => (
            <FormControlLabel
              control={<Radio className="radio" />}
              key={index}
              label={option}
              value={index + 1}
            />
          ))
        )} */}
      </RadioGroup>
    </div>
  );
};

export default ResultColumn;
